import { JSX } from "hono/jsx";

interface VoxelMenuProps {
  show: boolean;
  isPublic: boolean;
  isOwner: boolean;
  isAnonymous?: boolean;
  onClose: () => void;
  onTogglePublic: (isPublic: boolean) => void;
}

export const VoxelMenu = (
  { show, isPublic, isOwner, isAnonymous, onClose, onTogglePublic }:
    VoxelMenuProps,
) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div class="card w-96 bg-base-100 shadow-xl">
        <div class="card-body">
          <h2 class="card-title text-2xl font-bold mb-4">Game Menu</h2>

          {isOwner
            ? (
              <div class="form-control">
                <label
                  class={`label cursor-pointer justify-start gap-4 ${
                    isAnonymous ? "opacity-50" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    class="checkbox checkbox-primary"
                    checked={isPublic}
                    disabled={isAnonymous}
                    onChange={(e) =>
                      onTogglePublic((e.target as HTMLInputElement).checked)}
                  />
                  <span class="label-text text-lg font-medium">
                    Public Room
                  </span>
                </label>
                {isAnonymous && (
                  <div class="text-xs text-warning mt-1 px-1 font-bold">
                    Guests cannot make rooms public.{" "}
                    <a href="/login" class="underline">Log in</a> to enable.
                  </div>
                )}
                <div class="text-xs text-base-content/60 mt-2 px-1">
                  Public rooms appear in the main lobby list for everyone to
                  see.
                </div>
              </div>
            )
            : (
              <div class="alert alert-info shadow-sm">
                <span>You are a guest in this room.</span>
              </div>
            )}

          <div class="card-actions justify-end mt-8">
            <button class="btn btn-ghost" onClick={onClose}>Resume</button>
            <button
              class="btn btn-error"
              onClick={() => globalThis.location.href = "/"}
            >
              Leave Room
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
